import axios from 'axios';
import globals from "../config/appconfig";
import Utils from "../utils/Utils";
import moment from "moment";

function ToponomasticaService(props) {

     const urlComuni = globals["app-url-backend-toponomastica"] + "/comuni";
     const urlProvince = globals["app-url-backend-toponomastica"] + "/province";
     const urlNazioni = globals["app-url-backend-toponomastica"] + "/nazioni";
     const urlSiglaProvince = globals["app-url-backend-toponomastica"] + "/sigleProvince";
     const urlComuniCoordinate = globals["app-url-backend-toponomastica"] + "/comuniCoordinate";
    function getAllToponomasitica() {
        axios.get(urlComuni).then(data => {
            if (data) {
                let comuni = data.data;
                let dataOdierna = moment().format("YYYY-MM-DD");
                let comuniPerData = Utils.distinctComuni(comuni, dataOdierna)
                let codiceMap = Utils.arrayToMap(comuniPerData, "codice");
                let codiceMapDescrizione = Utils.arrayToMap(comuniPerData, "descrizione");
                sessionStorage.setItem("comuni", JSON.stringify(comuniPerData));
                sessionStorage.setItem("comuniPerCodice", JSON.stringify(codiceMap));
                sessionStorage.setItem("comuniPerDescrizione", JSON.stringify(codiceMapDescrizione));
                axios.get(urlProvince).then(data => {
                    if (data) {
                        let province = Utils.addFieldToArrayObjects(data.data, "descrizione", "dataInizioValidita", "dataFineValidita", "codice");
                        let codiceMap = Utils.arrayToMap(province, "codice");
                        let descrizioneMap = Utils.arrayToMap(province, "descrizione");
                        sessionStorage.setItem("province", JSON.stringify(province));
                        sessionStorage.setItem("provincePerCodice", JSON.stringify(codiceMap));
                        sessionStorage.setItem("provincePerDescrizione", JSON.stringify(descrizioneMap));
                        axios.get(urlNazioni).then(data => {
                            if (data) {
                                let nazioni = Utils.addFieldToArrayObjects(data.data, "descrizione", "dataInizioValidita", "dataFineValidita", "codice");
                                let codiceMap = Utils.arrayToMap(nazioni, "codice");
                                let italia = {descrizione: "Italia", codice: "100"}
                                nazioni.push(italia)
                                codiceMap["100"] = italia
                                let codiceMapDescrizioneNazioni = Utils.arrayToMap(nazioni, "descrizione");
                                sessionStorage.setItem("nazioni", JSON.stringify(nazioni));
                                sessionStorage.setItem("nazioniPerCodice", JSON.stringify(codiceMap));
                                sessionStorage.setItem("nazioniPerDescrizione", JSON.stringify(codiceMapDescrizioneNazioni));
                                axios.get(urlSiglaProvince).then(data => {
                                    if (data) {
                                        let siglaProvince = Utils.addFieldToArrayObjects(data.data, "descrizione", "dataInizioValidita", "dataFineValidita", "codice");
                                        let codiceMapSigle = Utils.arrayToMap(siglaProvince, "codice");
                                        let descrizioneMapSigle = Utils.arrayToMap(siglaProvince, "descrizione");
                                        sessionStorage.setItem("siglaProvince", JSON.stringify(siglaProvince));
                                        sessionStorage.setItem("siglaProvincePerCodice", JSON.stringify(codiceMapSigle));
                                        sessionStorage.setItem("siglaProvincePerDescrizione", JSON.stringify(descrizioneMapSigle));
                                        axios.get(urlComuniCoordinate).then(dataComuniCoordinate => {
                                            let comuniCoordinate = dataComuniCoordinate.data
                                            let comuniCoordinatePerData = Utils.distinctComuni(comuniCoordinate, dataOdierna)
                                            let comuniCoordinateMap = Utils.arrayToMap(comuniCoordinatePerData,"codice")
                                            sessionStorage.setItem("comuniCoordinate", JSON.stringify(comuniCoordinatePerData));
                                            sessionStorage.setItem("comuniCoordinatePerCodice", JSON.stringify(comuniCoordinateMap));
                                            sessionStorage.setItem("toponomasticaCaricataCorrettamente","true")
                                            props.setShowSpinner(false)
                                            props.renderApp()
                                        }).catch(reason => {
                                            console.log("[ERROR] Get comuni coordinate to SessionStorage: " + reason)
                                            props.setShowSpinner(false)
                                            props.renderApp()
                                        });
                                    }
                                }).catch(reason => {
                                    console.log("[ERROR] Get siglaProvince to SessionStorage: " + reason)
                                    props.setShowSpinner(false)
                                    props.renderApp()
                                });
                            }
                        }).catch(reason => {
                            console.log("[ERROR] Get nazioni to SessionStorage: " + reason)
                            props.setShowSpinner(false)
                            props.renderApp()
                        });
                    }
                }).catch(reason => {
                    console.log("[ERROR] Get province to SessionStorage: " + reason)
                    props.setShowSpinner(false)
                    props.renderApp()
                });
            }
        }).catch(reason => {
            console.log("[ERROR] Get Comuni to SessionStorage: " + reason)
            props.setShowSpinner(false)
            props.renderApp()
        });

    }


    return(getAllToponomasitica())

}
export default ToponomasticaService
